import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { orgUnitsStoreStateSelector } from '~/selectors';

export const useMyUnitIds = (): {
  aMyDeputyUnits: number[];
  aMyAltUnits: number[];
  aMyManUnits: number[];
  aMyHRUnits: number[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  return useSelector((state: StoreState) => {
    return orgUnitsStoreStateSelector(state);
  });
};
